import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// CSS
import './App.css';

// Context
import { CartProvider } from './context/CartContext';

// Pages
import Home from './pages/Home/Home';
import Menu from './pages/Menu/Menu';
import Order from './pages/Order/Order';

// Components
import Layout from './components/Layout/Layout';
import Custom from './pages/Custom/Custom';

const App = () => {
  return (
    <CartProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/order" element={<Order />} />
            <Route path="/mart" element={<Custom />} />
            {/* <Route path="/custom" element={<Custom />} /> */}
          </Routes>
        </Layout>
      </Router>
    </CartProvider>
  );
};

export default App;
